import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SimulationSessionView } from "./SimulationSessionView";
import { SimulationSessionViewStore } from "../../store/SimulationSessionViewStore";
import { useStore } from "../../../../hooks";

export const SimulationSessionViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/simulationSession/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SimulationSessionViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SimulationSessionView simulationSessionViewStore={store} />
      </PageLayout>
    </div>
  );
});
